import { useAppStore } from '@/stores/app'
import { UserRole } from '@/enums/domain'

export const isAuthenticated = (): boolean => {
    const appStore = useAppStore()
    return appStore.isLoggedIn()
}

export const hasRole = (roles: string[]): boolean => {
    const appStore = useAppStore()
    const role = appStore.userData?.role
    if (!role) return false
    return roles.includes(role)
}

export const isAdmin = (): boolean => hasRole([UserRole.SuperAdmin, UserRole.ProbeAdmin])
export const isSuperAdmin = (): boolean => hasRole([UserRole.SuperAdmin])
export const isReporter = (): boolean => hasRole([UserRole.Reporter])

// Who may export reports (v1.16): admins and the reporter role — not a user with the
// (own-reservations-only) report grant.
export const canExportReports = (): boolean => hasRole([UserRole.SuperAdmin, UserRole.ProbeAdmin, UserRole.Reporter])
